import { render } from "./Btn.vue?vue&type=template&id=ccc03378&scoped=true&ts=true&lang=pug"
import script from "./Btn.vue?vue&type=script&lang=ts"
export * from "./Btn.vue?vue&type=script&lang=ts"

import "./Btn.vue?vue&type=style&index=0&id=ccc03378&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccc03378"]])

export default __exports__